<template>
  <div>
    <div class="my-account-back-to-dashboard">
      <SvgImage
        class="my-account-back-to-dashboard__icon"
        height="10"
        icon="Icon_fleche_gauche"
        width="10"
      />
      <SfLink
        :link="localeRoute({ name: 'customer-my-profile' })"
        class="my-account-back-to-dashboard__text"
      >
        {{ $t("My profile") }}
      </SfLink>
    </div>
    <div class="my-account-heading">
      <h2 class="my-account-heading__title">
        {{ $t('My general conditions') }}
      </h2>
    </div>

    <ContentBlocks :identifiers="['my-cgv-cgu']" :title="false" class="content-bloc"/>
  </div>
</template>

<script>

import ContentBlocks from "~/components/ContentBlocks.vue";
import SvgImage from "~/components/General/SvgImage.vue";
import { SfLink } from '@storefront-ui/vue';

export default {
  components: {
    SvgImage,
    ContentBlocks,
    SfLink
  }
}
</script>

<style lang="scss">
@import '@/assets/theme/scss/modules/customer/dashboard.scss';
@import '@/assets/theme/scss/modules/customer/my-account.scss';
@import '@/assets/theme/scss/modules/customer/shared.scss';

.content-bloc {
  margin-top: 30px;
}
</style>
